import ApplicationSerializer from 'lumen/serializers/application';

export default class FavouriteCurrencySerializer extends ApplicationSerializer {
  attrs = {
    currency: 'code',
  };

  primaryKey = 'currency';

  payloadKeyFromModelName(): string {
    return 'favourite-currency';
  }
}
